import { memo } from "react";
import DataFormButtonGroup from "./DataFormButtonGroup";

const DataFormFooter = ({}) => {
  return (
    <div className="form-group row mt-3">
      <div className="col-12 col-md-4 text-left"></div>
      <DataFormButtonGroup />
    </div>
  );
};

export default memo(DataFormFooter);
